import React, { useState } from 'react'
import { pick } from 'lodash-es'
import styled from '@emotion/styled'
import { Login, Register } from '@vt/comps'
import { useLogin, useTitle, useProjectStore } from '@vt/hooks'
import { ThemeCommon } from './styled/common'
// import zrzhTitle from './title-zrzh-login.png'
import './styled/index.css'

const Container = styled.div`
  color: #2d3748;
  .login-input {
    appearance: none;
    padding-left: transparent;
    padding-right: transparent;
    font-size: 0.875rem;
    line-height: transparent;
    border: none;
    background: transparent;
  }
  .phone:-webkit-autofill {
    box-shadow: 0 0 0 1000px #fff inset;
  }
  .pwd-common:-webkit-autofill {
    box-shadow: 0 0 0 1000px #fff inset;
  }
  .pwd-screen:-webkit-autofill {
    box-shadow: 0 0 0 1000px #1a1b3a inset;
  }
  .dd-icon {
    width: 28px;
    height: 28px;
  }
`

const LoginPage = function () {
  const { cusKey: key } = useProjectStore((s) => pick(s, ['cusKey']))
  const useLoginApi = useLogin()
  const { customInfo, clearAllValues } = useLoginApi
  const { prefix, title, allowLoginType } = customInfo

  let Theme = null
  switch (prefix) {
    case 'common':
      Theme = ThemeCommon
      break
    default:
      Theme = ThemeCommon
      break
  }
  useTitle(title)

  const [isRegister, setIsRegister] = useState(false)

  return (
    <Container
      className={`w-full parent-container overflow-y-auto ${prefix}-container`}
    >
      <Theme>
        <p className={`${prefix}-web-title`}>{title}</p>
        <div
          className={`${prefix}-contentBox content-box content-box-${prefix}`}
        >
          {isRegister && !key ? (
            <Register
              prefix={prefix}
              useLoginApi={useLoginApi}
              onBack={() => {
                setIsRegister(false)
                clearAllValues()
              }}
              onLogin={(res, redirectPage) => {
                if (redirectPage) {
                  redirectPage()
                }
              }}
            />
          ) : (
            <Login
              prefix={prefix}
              // css
              loginBtnWidth="100%"
              // 暂时添加 用来判断登录方式的参数
              allowLoginType={allowLoginType}
              useLoginApi={useLoginApi}
              loginCallBack={(res, redirectPage) => {
                if (redirectPage) {
                  redirectPage()
                }
              }}
              onRegister={() => {
                setIsRegister(true)
                clearAllValues()
              }}
            />
          )}
        </div>
      </Theme>
    </Container>
  )
}

export default LoginPage
